import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin'
import {post} from "../../axios/post";
import {getRequest, obj2params} from "../../util/utils";

class SearchResult extends Component {
    constructor(props, context) {
        super(props, context);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.loadingStyle = this.loadingStyle.bind(this);

    }

    /*

    <tr key={index} style={book.is_scanned ? {} : {backgroundColor: '#d6d6d6'}}
    */


    /** @namespace this.props.searchInfo.bookList */
    render() {
        let bookList = this.props.searchInfo.bookList;
        let data = bookList.data || [];
        // console.log("data",data);
        // console.log("bookList",bookList);
        return (
            <div>
                <div className="list">
                    <table width="100%" className="listTable" cellSpacing='0'>
                        <thead>
                        <tr>
                            <th>书名</th>
                            <th>作者</th>
                            <th>出版者</th>
                            <th>出版日期</th>
                            <th>馆藏地</th>
                            {/*<th>著录价格</th>*/}
                            <th>索书号</th>
                            <th>条码号</th>
                            <th>是否借出</th>
                            <th style={{backgroundColor:'#ffffff',border:'0px solid #ABB9D3'}}></th>
                            {/*<th>是否借出</th>*/}
                            {/*<th>是否在架</th>*/}
                        </tr>
                        </thead>
                        <tbody>
                        {
                            data.map((book, index) => {
                                    {/*<tr key={index} style={book.is_scanned ? {} : {backgroundColor: '#d6d6d6'}}*/
                                    }
                                    {/*onClick={book.is_scanned ? this.addressInfo.bind(this, book) : null}>*/
                                    }
                                    // onClick={this.addressInfo.bind(this, book)}>
                                    // noinspection JSUnresolvedVariable

                                    // console.log('isBookRoomOut',data[0].isBookRoomOut);
                                    // console.log('book -> data1',book.data1);
                                    // if(data.isBookRoomOut==='true'){


                                    if (book.is_scanned) {
                                        // console.log("图书在库");
                                        /**
                                         * 图书在库
                                         */
                                        return (

                                            <tr key={index}

                                                // style={book.data1==1 ? {} : {backgroundColor: '#D5D5D5'}}
                                                style={book.data1 == 1 ? {} : {backgroundColor: '#EBF7FD'}}
                                                onClick={book.data1 == 1 ? this.addressInfo.bind(this, book) : null}>

                                                <td style={book.data1 == 1 ? {textDecoration: 'underline'} : {}}>
                                                    <a
                                                        className="listTitle">{book.book_name}</a>
                                                </td>
                                                <td>{book.author}</td>
                                                <td>{book.publish_house}</td>
                                                <td>{book.publish_year}</td>
                                                <td>
                                                    <nobr>{book.book_current_place_name}</nobr>
                                                </td>
                                                {/*<td>{book.price}</td>*/}
                                                <td>{book.callno}</td>
                                                <td>{book.book_barcode}</td>
                                                {/*<td style={ {color: '#3399ff'}}>{book.data1 ==1 ? '未借出' : '已借出'}</td>*/}
                                                {/*<td style={ {color: '#3399ff',textDecoration:'underline'}}>{book.data1 ==1 ? '未借出' : '已借出'}</td>*/}
                                                {/*<td style={ {color: '#3399ff',textDecoration:'underline'}}>{book.data1 ==1 ? '未借出' : '已借出'}</td>*/}
                                                <td style={book.data1 == "1" ? {
                                                    color: '#3399ff',
                                                    textDecoration: 'underline'
                                                } : {color: '#3399ff'}}>{book.data1 == "1"? '未借出' : '已借出'}</td>
                                                {/*<td style={book.data1 ==2 ? {color: '#0000ff'} : {color: '#3399ff'}}>{book.data1 ==2 ? '未借出' : '已借出'}</td>*/}
                                                {/*<td >是</td>*/}

                                                <td style={ book.data1 == "1" ? {backgroundColor:'#ffffff',border:'0px solid #ABB9D3'}:{display:'none'} }><button className="btn12" type="button" >查看定位</button></td>
                                            </tr>


                                        )

                                    } else {
                                        /**
                                         * 图书不在库 判断是否允许跳转外部链接
                                         */
                                            // console.log("图书不在库");

                                        // book.data1 =2;
                                        var res = false;
                                        // var res = true ;
                                        var i = 0
                                        for (i; i < book.book_current_place_list.length; i++) {
                                            // if(book.book_current_place_list[i] != ""){
                                            //     continue;
                                            // }

                                            if (book.book_current_place_name == book.book_current_place_list[i]  ) {
                                                res = true;
                                                break;
                                            }
                                        }
                                        if (book.data1 == 1 && res) {
                                            res = true;
                                        }else {
                                            res=false;
                                        }
                                        if(book.isBookRoomOut != "true"){
                                            console.log(book.isBookRoomOut );
                                            res =false;
                                        }

                                        return (

                                            <tr key={index}
                                                // style={book.data1 ==2  ? {} : {backgroundColor: '#D5D5D5'}}
                                                style={book.data1 == "1" ? {} : {backgroundColor: '#EBF7FD'}}
                                                onClick={book.isBookRoomOut == "true" ? this.addressout.bind(this, book) : null}>

                                                <td style={res ? {textDecoration: 'underline'} : {}}>
                                                    <a
                                                        className="listTitle">{book.book_name}</a>
                                                </td>
                                                <td>{book.author}</td>
                                                <td>{book.publish_house}</td>
                                                <td>{book.publish_year}</td>
                                                <td>
                                                    <nobr>{book.book_current_place_name}</nobr>
                                                </td>
                                                {/*<td>{book.price}</td>*/}
                                                <td>{book.callno}</td>
                                                <td>{book.book_barcode}</td>
                                                <td style={res ? {
                                                    color: '#000099',
                                                    textDecoration: 'underline'
                                                } : {color: '#000099'}}>{book.data1 == "1" ? '未借出' : '已借出'}</td>
                                                {/*<td style={book.data1 ==2  ? {color: '#000099'} : {color: '#33ccff'}}>{book.data1 ==2 ? '未借出' : '已借出'}</td>*/}
                                                {/*<td style={{color: '#007dfd'}}>否</td>*/}
                                                <td style={ res ? {backgroundColor:'#ffffff',border:'0px solid #ABB9D3'}:{display:'none'} }><button className="btn13" type="button" >查看定位</button></td>

                                            </tr>


                                        )

                                    }

                                }
                            )
                        }
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colSpan="8">

                                <a className="btn2" onClick={this.props.cutPageSearch} href="javascript:">上一页</a>&nbsp;
                                <a className="btn2" onClick={this.props.addPageSearch} href="javascript:">下一页</a>
                                &nbsp;
                                共 <span>{bookList.pageCount}</span> 页，
                                第 <span>{bookList.currentPage}</span> 页
                            </td>
                        </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        )
    }

    /**
     * 图书地址 跳转页面展示
     * @param book
     */
    addressInfo(book) {
        const searchInfoActions = this.props.searchInfoActions;
        let searchInfo = this.props.searchInfo;
        let result = post('/analysisapp/QueryBookPositionInfo?', {
            barCode: book.book_barcode,
            // barCode: '10556821', // 这里好多数据不存在 先写死一个
            type: 2,
            //outType 1为内部跳转至定位页 2为外部三方跳转到定位页
            outType: 1,
            planId: 'all',
        });
        this.loadingStyle('inline');
        let bookPosition = [];
        result.then(data => {
            bookPosition = data;
            // console.log(data);
        }).catch(err => {
            console.log('Search Result----------- >>>>> ' + err.toString());
            alert("很抱歉，查询失败！")
        }).finally(() => {

            if (bookPosition.length === 0) {
                // noinspection JSUnresolvedFunction
                searchInfoActions.advancedSearch(
                    {
                        ...searchInfo,
                        bookPosition: bookPosition,
                        bookAddressStyle: {},
                        clickBook: book
                    }
                );
                // if (bookPosition.length === 0) {
                //     alert("很抱歉，未能查询到图书的位置信息！")
                // }
            } else if (bookPosition.length === 1) {


                /*     console.log('SearchResult to bookdetail == ', this.props.searchInfo);
                     console.log('SearchResult', this.props.searchInfo.bookList.data[0]);
                     console.log('sda',bookPosition);*/
                this.props.searchInfo.bookPosition = bookPosition;
                this.props.searchInfo.clickBook = bookPosition;
                this.props.searchInfo.clickType = 1;
                this.props.history.push({
                    pathname: '/bookDetail?' + obj2params(getRequest()),
                    state: this.props.searchInfo
                });


            } else {
                // noinspection JSUnresolvedFunction
                searchInfoActions.advancedSearch(
                    {
                        ...searchInfo,
                        bookAddressStyle: {},
                        bookPosition: bookPosition,
                        clickBook: book
                    }
                );

            }
            this.loadingStyle('none');


        });
    }

    addressout(book) {
        console.log('book', book);

        var res = false;
        var i = 0
        for (i; i < book.book_current_place_list.length; i++) {
            if (book.book_hold_place_name == book.book_current_place_list[i]) {
                res = true;
            }
        }


        if (book.data1 == "1" && res) {
// console.log("跳转第三方定位页");
            window.location.href = (book.bookRoomOutUrl + "?bookid=" + book.book_barcode);
            // window.location.href = (book.bookRoomOutUrl );
            // window.open(book.bookRoomOutUrl);

        }

    }





    loadingStyle(display) {
        let loadInfoActions = this.props.loadInfoActions;
        let loadInfo = this.props.loadInfo;
        // noinspection JSUnresolvedFunction
        loadInfoActions.changeStyle({
            ...loadInfo,
            display: display,
        });
    }

}

export default SearchResult;



// WEBPACK FOOTER //
// ./src/components/home/SearchResult.js